import { OutputRow as SessionTypesData } from "api/getSessionTypes";

interface Params {
	sessionType: SessionTypesData;
}

export function formatSessionType({ sessionType }: Params) {
	return sessionType.sessionTitle;
}
